export const PANEL_WIDTH = 304
export const MOBILE_APP_URL = 'namesandfaces://open'
